import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PortalModule } from "@angular/cdk/portal";
import { AccordionModule } from "ng-uikit-pro-standard";
import { CartLayoutComponent } from "./cart-layout/cart-layout.component";
import { SharedCoreModule } from "../shared-core/shared-core.module";
import { AccountModule } from "../account/account.module";
import { CartCustomizationComponent } from "./cart-customization/cart-customization.component";
import { GiftCardCartCustomizationComponent } from "./cart-customization/gift-card-cart-customization/gift-card-cart-customization.component";
import { WebWrapperModule } from "./web-wrappers/web-wrapper.module";
import { ProductRecommendationsModule } from "./product-recommendations/product-recommendations.module";
import { FooterCopyrightComponent } from "./footer/footer-copyright/footer-copyright.component";
import { AddPaymentMethodDialogComponent } from "./add-payment-method-dialog/add-payment-method-dialog.component";
import { UpdatePaymentMethodDialogComponent } from "./update-payment-method-dialog/update-payment-method-dialog.component";
import { CreditCardFormComponent } from "./credit-card-form/credit-card-form.component";
import { AddressEditComponent } from "../checkout/address-edit/address-edit.component";
import { ShippingComponent } from "./shipping/shipping.component";
import { ShippingSelectorComponent } from "./shipping/shipping-selector/shipping-selector.component";
import { PickupSelectorComponent } from "./shipping/pickup-selector/pickup-selector.component";
import { NgxAutocomPlaceModule } from "ngx-autocom-place";
import { NgxMaskModule } from "ngx-mask";
import {CheckoutSummaryComponent} from "../checkout/summary/checkout-summary/checkout-summary.component";

@NgModule({
    declarations: [
        AddPaymentMethodDialogComponent,
        UpdatePaymentMethodDialogComponent,
        CreditCardFormComponent,
        CartLayoutComponent,
        CartCustomizationComponent,
        GiftCardCartCustomizationComponent,
        CartCustomizationComponent,
        AddressEditComponent,
        FooterCopyrightComponent,
        ShippingComponent,
        ShippingSelectorComponent,
        PickupSelectorComponent,
        CheckoutSummaryComponent
    ],
    imports: [
        CommonModule,
        SharedCoreModule,
        NgxAutocomPlaceModule,
        WebWrapperModule,
        AccordionModule,
        AccountModule,
        PortalModule,
        ProductRecommendationsModule,
        NgxMaskModule
    ],
    exports: [
        CommonModule,
        CartLayoutComponent,
        NgxAutocomPlaceModule,
        WebWrapperModule,
        ProductRecommendationsModule,
        NgxMaskModule,
        CartCustomizationComponent,
        CreditCardFormComponent,
        AddressEditComponent,
        ShippingComponent,
        CheckoutSummaryComponent
    ]
})
export class SharedModule {}
